import { render, staticRenderFns } from "./MainCoachPop.vue?vue&type=template&id=61dedfdb&scoped=true&"
import script from "./MainCoachPop.vue?vue&type=script&lang=js&"
export * from "./MainCoachPop.vue?vue&type=script&lang=js&"
import style0 from "./MainCoachPop.vue?vue&type=style&index=0&id=61dedfdb&lang=scss&scoped=true&"
import style1 from "./MainCoachPop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dedfdb",
  null
  
)

export default component.exports